export default "__VITE_ASSET__BIKsvqqe__"